<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>{{$t('common.divisions.singular')}}</v-toolbar-title>
    </v-toolbar>
    <v-divider/>
    <v-card-text>
      <google-address-search
        :location="product.location"
        @change-address="changeAddress"
      />
    </v-card-text>
  </v-card>
</template>
<script>
import { isEqual, get } from 'lodash'
import GoogleAddressSearch from "../Common/GoogleAddressSearch"

export default {
  components: { GoogleAddressSearch },
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      original: {
        label: '',
        coordinates: {
          lat: null,
          long: null
        },
      },
      model: {
        label: '',
        coordinates: {
          lat: null,
          long: null
        },
      }
    }
  },
  mounted() {
    this.setOriginalAndModel(this.product)
  },
  methods: {
    changeAddress(addressData) {
      const { label, data } = addressData
      const { latitude, longitude } = data

      const newModel = {
        label,
        coordinates: {
          lat: latitude,
          long: longitude
        },
      }

      this.model = { ...newModel }
      this.emitChange()
    },
    setOriginalAndModel(product) {
      const location = get(product, 'location', {})
      const { coordinates = {} } = location || {}
      const { _lat: lat, _long: long } = coordinates
      const model = { lat, long }

      this.original = { ...model }
      this.model = { ...model }
    },
    emitChange() {
      if (!isEqual(this.original, this.model)) {
        this.$emit('change', { ...this.model })
      }
    }
  }
}
</script>
